import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import { Collapse } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import FilterArticle from 'hooks/FilterArticle';

export default function ModalDiscountScale(props) {
  const dScale = props.model;
  const [dataChanging, setDataChanging] = useState(dScale);

  const [qMax, setQMax] = useState(null);

  const [zones, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [canals, setCanals] = useState([]);

  const [nameArticle, setNameArticle] = useState('');
  const [checkDisplay, setCheckDisplay] = useState(true);

  function setOpen() {
    props.setOpen({ open: false });
    setNameArticle('');
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listBureaus() {
    let response = await wsGetAll('base/bureau');
    if (response.success) {
      response.data.unshift({ id: 0, description: 'Todos' });
      setBureaus(response.data);
    }
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (dScale.open && !!dScale.ItemName) {
      setNameArticle(dScale.ItemName);
    }
    if (dScale.open) {
      listZones();
      listBureaus();
      listCanals();
    }
  }, [dScale.open]);

  return (
    <Modal
      title="Descuento escala"
      model={dScale}
      setOpen={setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/discount-scale"
      state
    >
      {!dScale.logi_product_id ? (
        <Card style={{ margin: 0, marginTop: '20px' }}>
          <CardHeader
            style={{
              cursor: 'pointer',
              alignItems: 'center'
            }}
            onClick={() => {
              setCheckDisplay((prev) => !prev);
            }}
            icon
          >
            <h4
              style={{
                color: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end'
              }}
            >
              {nameArticle === '' ? 'Selecciona producto' : nameArticle}
              <ArrowDropDown />
            </h4>
          </CardHeader>
          <Collapse in={checkDisplay} key={1}>
            <div
              elevation={4}
              style={{
                padding: '10px',
                margin: 'auto',
                marginBottom: '8px !important',
                width: '100%'
              }}
            >
              <FilterArticle
                fullWidth={true}
                article
                defaultValue={dScale}
                setNameArticle={setNameArticle}
                setDataChanging={setDataChanging}
                dataChanging={dataChanging}
                reqField={['product']}
              />
            </div>
          </Collapse>
        </Card>
      ) : (
        <h4 style={{ textAlign: 'center' }}>{nameArticle}</h4>
      )}
      {zones.length > 0 && dScale.open ? (
        <Autocomplete
          multiple={!!dScale.id ? false : true}
          disableCloseOnSelect={true}
          size="small"
          options={zones}
          getOptionLabel={(option) => option.description}
          defaultValue={!!dScale ? zones.find((zone) => zone.id == dScale.base_zone_id) : undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Zona"
              margin="normal"
              required={!!dScale.id ? false : dataChanging.zones?.length > 0 ? false : true}
            />
          )}
          onChange={(e, item) => {
            if (!!item) {
              let idZones;
              if (!dScale.id) {
                idZones = item.map((item) => item.id);
              }
              return handleChange(
                !!dScale.id ? 'base_zone_id' : 'zones',
                !!dScale.id ? item.id : idZones
              );
            }
            handleChange(!!dScale.id ? 'base_zone_id' : 'zones', null);
          }}
        />
      ) : undefined}

      {bureaus.length > 0 ? (
        <Autocomplete
          options={bureaus}
          getOptionLabel={(option) => option.description}
          defaultValue={
            !!dScale ? bureaus.find((bureau) => bureau.id == dScale.base_bureau_id) : undefined
          }
          renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" />}
          onChange={(e, item) => {
            if (!!item) {
              if (item.id === 0) {
                handleChange('base_bureau_id', null);
              } else {
                handleChange('base_bureau_id', item.id);
              }
            } else {
              handleChange('base_bureau_id', null);
            }
          }}
        />
      ) : undefined}
      {canals.length > 0 ? (
        <Autocomplete
          options={canals}
          getOptionLabel={(option) => option.description}
          defaultValue={
            !!dScale ? canals.find((oCanal) => oCanal.id == dScale.base_canal_id) : undefined
          }
          renderInput={(params) => <TextField {...params} label="Canal" margin="normal" required />}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_canal_id', item.id);
            }
            handleChange('base_canal_id', null);
          }}
        />
      ) : undefined}

      <TextField
        label="Cantidad mínima"
        name="quantity_min"
        margin="normal"
        type="number"
        fullWidth
        defaultValue={!!dScale ? dScale.quantity_min : ''}
        inputProps={{ max: qMax, min: 0, step: 0.01 }}
        required
      />

      <TextField
        label="Cantidad máxima"
        name="quantity_max"
        margin="normal"
        type="number"
        fullWidth
        defaultValue={!!dScale ? dScale.quantity_max : ''}
        onChange={(e) => setQMax(e.target.value)}
        inputProps={{ min: 0, step: 0.01 }}
        required
      />

      <TextField
        label="Descuento %"
        name="discount"
        margin="normal"
        type="number"
        inputProps={{ step: 0.01, min: 0.0, max: 25 }}
        fullWidth
        defaultValue={!!dScale ? dScale.discount : ''}
        required
      />
    </Modal>
  );
}
